import qs from "qs";

const PAGE_TITLES = {
  "/search": "Search results for: %s",
  "/search/videos": "Search videos for: %s",
  "/search/images": "Search images for: %s",
  "/browse/signs-and-symptoms": "Signs/Symptoms",
  "/browse/diseases-and-conditions": "Diseases/Conditions",
  "/browse/tests-and-labs/imaging-tests": "Imaging Tests",
  "/browse/tests-and-labs/lab-tests": "Lab Tests",
  "/browse/tests-and-labs/assessments": "Assessments",
  "/browse/tests-and-labs/diagnostic-procedures": "Diagnostic Procedures",
  "/browse/care-interventions": "Care Interventions",
  "/browse/drug-monographs": "Drugs",
  "/browse/skills/nursing-skills": "Nursing Skills",
  "/browse/skills/allied-health-skills": "Health Profession Skills",
  "/browse/skills/clinical-assistant-skills": "Clinical Assistant Skills",
  "/browse/skills/cultural-care-skills": "Cultural Care Skills",
  "/browse/skills/patient-instruction-skills": "Patient Instruction Skills",
  "/browse/patient-handouts/diseases-and-conditions":
    "Diseases & Conditions Patient Handouts",
  "/browse/patient-handouts/procedures-and-tests":
    "Procedures & Tests Patient Handouts",
  "/browse/patient-handouts/health-and-wellness":
    "Health & Wellness Patient Handouts",
  "/browse/patient-handouts/discharge-instructions":
    "Discharge Instructions Patient Handouts",
  "/browse/leadership": "Leadership",
  "/browse/leadership/case-management": "Case Management",
  "/browse/leadership/finance-and-budget": "Finance and Budget",
  "/browse/leadership/healthcare-costs": "Healthcare Costs",
  "/browse/leadership/human-resources": "Human Resources",
  "/browse/leadership/leadership-development": "Leadership Development",
  "/browse/leadership/national-patient-safety-goals":
    "National Patient Safety Goals",
  "/browse/leadership/preceptorship": "Preceptorship",
  "/browse/leadership/process-theory-and-models-of-care":
    "Process, Theory, and Models of Care",
  "/browse/leadership/professional-development-and-education":
    "Professional Development and Education",
  "/browse/leadership/quality-compliance-and-patient-satisfaction":
    "Quality, Compliance, and Patient Satisfaction",
  "/browse/leadership/staffing-and-scheduling": "Staffing and Scheduling",
  "/browse/leadership/workplace": "Workplace",
  "/browse/cultural-overviews": "Cultural Overviews",
  "/browse/interventions/treatment-modalities": "Treatment Modalities",
  "/admin/hidden": "Content Admin",
  "/admin/notes": "Content Admin",
  "/admin/skills": "Content Admin"
};

export default (path, search) => {
  let title = PAGE_TITLES[path];

  if (title && path.includes("/search")) {
    const { q } = qs.parse(search, { ignoreQueryPrefix: true });
    title = q ? title.replace("%s", q) : "";
  }

  return title;
};
